import { IGlobalState } from '../../Root/store/appReducer'

export const getNotification = ({ notifications }: IGlobalState) => notifications.notification
